module.exports = __webpack_public_path__ + "static/media/potez631.be2fa6ea.jpg";